import React, { useRef } from 'react'
import { Link } from 'gatsby'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { ESW_CLASSNAMES } from '../../constants'
import RemoveFromCart from './remove-from-cart'
import PriceDisplay from './price-display'
import useGetAllBuilderProducts from '../hooks/useGetAllBuilderProducts'
import classNames from 'classnames'

export default function CartItem({ item }) {
    const allProduct = useGetAllBuilderProducts()
    const rowRef = useRef(null)

    const { product_sku, qty } = item    
    const product = allProduct.find(({ sku }) => sku === product_sku)
    const { name, url, category, image } = product || {}

    if(!product) return
    return <div
        ref={rowRef}
        className={classNames(
            ESW_CLASSNAMES.CART_ITEM,
            'border-bottom border-dark pb-3 mb-3'
        )}
    >
        <Row className='align-items-center'>
            <Col xs='auto'>
                <Link to={url}>
                    <img src={image} alt='' style={{ width: 100 }} objectFit='contain' />
                </Link>
            </Col>
            <Col className='d-none d-md-flex flex-column'>
                <Link to={url} className='text-black text-decoration-none'>
                    <p className='ff-primary text-uppercase fw-bold mb-0' style={{ fontSize: 24 }}>
                        {name}
                    </p>
                    <p className='text-secondary text-uppercase fw-semibold mb-0'>
                        {category}
                    </p>
                </Link>
            </Col>
            <Col>
                <div className='d-flex d-md-none flex-column mb-3'>
                    <p className='ff-primary text-uppercase fw-bold mb-0' style={{ fontSize: 20 }}>
                        {name}
                    </p>
                    <p className='text-secondary text-uppercase fw-semibold mb-0'  style={{ fontSize: 12 }}>
                        {category}
                    </p>
                </div>
                <PriceDisplay
                    item={item}
                    product={product}
                    quantity={qty}
                    style={{ fontSize: 18 }}
                    className='d-flex align-items-center gap-2 mb-0 fw-semibold'
                    eswPriceClassName={ESW_CLASSNAMES.CART_PRICE}
                />
            </Col>
            <Col xs='auto'>
                <RemoveFromCart el={rowRef} product={product} className='flex-center'>
                    <img src='/svg/cancel-icon-black.svg' alt='' />
                </RemoveFromCart>
            </Col>
        </Row>
    </div>
}